<template>
  <LoaderWrapper ref="pageLoader" class="h-100">
    <div class="row  m-4 mt-0">
      <div class="col-sm-12">
        <div class="row">

          <div class="col-sm-12">
            <div class="card card-body">
              <div class="row">
                <div class="form-group col-sm-12">
                </div>
              </div>

              <div class="overflow-auto">
                <table class="table table-striped border-light align-middle text-left text-nowrap position-relative">
                  <thead>
                  <tr>
                    <th class="text-capitalize-first w-25">{{ helper.trans('labels.id') }}</th>
                    <th class="text-capitalize-first">{{ helper.trans('labels.name') }}</th>
                    <th class="text-capitalize-first">{{ helper.trans('labels.trader') }}</th>
                    <th class="text-capitalize-first">{{ helper.trans('labels.req_count') }}</th>
                    <th class="text-capitalize-first">{{ helper.trans('labels.active_req_count') }}</th>
                    <th></th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="group in response.items" :key="group.id" class="">
                    <td> {{ group.id }}</td>
                    <td>
                      {{ group.name }}
                    </td>
                    <td>
                      <UserNameLabel v-if="group.trader" :user="group.trader"/>
                    </td>
                    <td>{{ group.requisitesCount }}</td>
                    <td>{{ group.activeRequisitesCount }}</td>
                    <td class="text-end">
                      <button v-if="isAdmin || isOperator" type="button" @click="toggleRequisites(group, false)" class="btn btn-sm btn-outline-dark text-nowrap me-2">
                        <i class="fa fa-toggle-off text-secondary"></i> <span class="text-capitalize-first">{{helper.trans('labels.requisites_deactivate')}}</span>
                      </button>
                      <button v-if="isAdmin || isOperator" type="button" @click="toggleRequisites(group, true)" class="btn btn-sm btn-outline-dark text-nowrap">
                        <i class="fa fa-toggle-on text-success"></i> <span class="text-capitalize-first">{{helper.trans('labels.requisites_activate')}}</span>
                      </button>
                    </td>
                  </tr>
                  </tbody>
                </table>

                <b-pagination
                  v-if="response.totalCount > response.items.length"
                  v-model="page"
                  :total-rows="response.totalCount"
                  :per-page="response.limit"
                  :limit="20"
                  @update:modelValue="load()"
                  :prev-text="helper.trans('button.back')"
                  :next-text="helper.trans('button.next')"
                  align="start"
                  first-number
                  hide-goto-end-buttons
                  hide-ellipsis
                ></b-pagination>
              </div>

            </div>
          </div>

        </div>
      </div>
    </div>
  </LoaderWrapper>
</template>
<script lang="ts">
import LoaderWrapper from "@/components/LoaderWrapper.vue";
import CopyButton from "@/components/CopyButton.vue";
import {computed, defineComponent, onMounted, reactive, ref, toRefs} from 'vue'
import {dateHelper} from "@/service/DateHelper";
import {numberFormatter} from "@/service/NumberFormatter";
import APIClient from "@/service/APIClient";
import PaginatedResponseDTO from "@/models/PaginatedResponseDTO";
import {helper} from "@/service/CommonHelper";
import {BModal, BPagination} from "bootstrap-vue-3";
import RequisitesForm from "@/components/Form/RequisitesForm.vue";
import {useNotification} from "@kyvg/vue3-notification";
import DeviceList from "@/components/DeviceList.vue";
import {useStore} from "vuex";
import GroupsList from "@/components/GroupsList.vue";
import PaginationDTO from "@/models/PaginationDTO";
import UserNameLabel from "@/components/UserNameLabel.vue";
import TraderRequisiteGroupDTO from "@/models/TraderRequisiteGroupDTO";

const api = new APIClient();
const notification = useNotification()

export default defineComponent({
  name: 'RequisitesGroups',
  components: {
    LoaderWrapper,
    CopyButton,
    BPagination,
    BModal,
    RequisitesForm,
    DeviceList,
    GroupsList,
    UserNameLabel
  },
  setup() {
    const store = useStore();

    const pageLoader = ref<InstanceType<typeof LoaderWrapper> | null>(null)

    const state = reactive({
      page: 1,
      response: {
          limit: 20,
          offset: 0,
          totalCount: 0,
          items: []
      } as PaginatedResponseDTO<TraderRequisiteGroupDTO>
    });

    const toggleRequisites = async (item: TraderRequisiteGroupDTO, isActive: boolean) => {
      pageLoader.value?.show()
      try {
        const dto = await api.traderRequisiteGroupToggleRequisites(item.id, isActive ? 'activate' : 'deactivate')
        item.requisitesCount = dto.requisitesCount
        item.activeRequisitesCount = dto.activeRequisitesCount
        item.name = dto.name
        notification.notify({title: isActive ? helper.trans("labels.requisites_activated") : helper.trans("labels.requisites_deactivated")})
      } finally {
        pageLoader.value?.hide()
      }
    }

    const load = async () => {
      state.response.offset = state.response.limit * (state.page - 1)
      pageLoader.value?.show()
      state.response = await api.traderRequisiteGroups(state.response)
      const traderIds = state.response.items.map(req => req.traderId);

      let traders = [];

      if (store.getters.isAdmin || store.getters.isOperator) {
        for (const trader of (await api.traders({offset:0, limit: traderIds.length} as PaginationDTO, {ids: traderIds})).items) {
          traders[trader.id] = trader
        }
      }

      for (const item of state.response.items) {
        item.trader = traders[item.traderId] ?? null;
      }

      pageLoader.value?.hide()
    }


    onMounted(() => {
      load();
    });

    return {
      ...toRefs(state),
      pageLoader,
      dateHelper,
      helper,
      numberFormatter,
      load,
      toggleRequisites,
      store,
      isAdmin: computed(() => store.getters.isAdmin),
      isOperator: computed(() => store.getters.isOperator),
      isTrader: computed(() => store.getters.isTrader),
    }
  }
})
</script>
